import { countedAmounts } from '@debbie/common/dist/economy/helpers/vouchers.js';
import { formatMoney } from '@debbie/common/dist/format-money.js';
import { Site } from '@debbie/common/dist/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import Money from '../../Money.js';
// What was entered, shown on hover once something of it was written off.
// Debtors only see what they owe.
export const originalAmountHover = (site, lang, caseVoucher) => {
    const { originalAmount, writtenOffAmount } = countedAmounts(caseVoucher);
    if (site === Site.Debtor ||
        originalAmount === null ||
        writtenOffAmount === 0) {
        return null;
    }
    return `${lang.economy.originalAmount}: ${formatMoney(lang.is.currently, Math.abs(originalAmount))}`;
};
// What of a voucher counts toward the balance, the same on both engines.
const VoucherAmount = (props) => {
    const site = useSelector((s) => s.site);
    const lang = useSelector((s) => s.lang);
    const hover = originalAmountHover(site, lang, props.caseVoucher);
    return (React.createElement(Money, { color: props.color, amount: countedAmounts(props.caseVoucher).amount, tooltip: hover ?? undefined }));
};
export default VoucherAmount;
//# sourceMappingURL=VoucherAmount.js.map